import React from "react"
import {graphql} from "gatsby"

import Layout from "../components/layout/layout"
import SEO from "../components/seo/seo"

class CaseStudyTemplate extends React.Component {
  render() {
    const post = this.props.data.markdownRemark;
    const siteTitle = this.props.data.site.siteMetadata.title;

    return (
      <Layout>
        <SEO
          title={siteTitle}
          description={post.frontmatter.title}
        />
        <span className="category-title">Case Study</span>
        <h1 className="h2">{post.frontmatter.title}</h1>
        <div dangerouslySetInnerHTML={{ __html: post.html }} />
      </Layout>
    )
  }
}

export default CaseStudyTemplate;

export const pageQuery = graphql`
  query CaseStudyBySlug($slug: String!) {
    site {
      siteMetadata {
        title
      }
    }
    markdownRemark(fields: { slug: { eq: $slug } }) {
      id
      html
      frontmatter {
        title
        description
      }
    }
  }
`